import axios from 'axios';
import {encryptStorage} from '../utility/Storage';
const URL_PREFIX = window.CONFIG_URL_PREFIX;
const URL_PORT = window.CONFIG_URL_PORT;

const appAxios = axios.create({
  baseURL: URL_PREFIX + URL_PORT, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

export const setAuthToken = (token) => {
  if (token) {
    encryptStorage.setItem('token', token);
  } else {
    encryptStorage.removeItem('token');
  }
};

export const setUserRole = (role) => {
  encryptStorage.setItem('userRole', role);
};

export const setUserGroup = (group) => {
  encryptStorage.setItem('userGroup', group);
};

export const getAccessToken = () => {
  return encryptStorage.getItem('token');
};

export const getUserRole = () => {
  return encryptStorage.getItem('userRole');
};

export const getVendorId = () => {
  return encryptStorage.getItem('vendorId');
};

export const getUserBranch = () => {
  return encryptStorage.getItem('userBranch');
};

export const getUserGroup = () => {
  return encryptStorage.getItem('userGroup');
};

export const getReCaptchaToken = () => {
  return  encryptStorage.getItem('tokenReCaptcha');
}

export default appAxios;
